import { generatePath } from 'react-router-dom';
import {
  PARAM_NAME,
  //
  ROOT,
  GAME,
  DEMO_GAME,
  BONUSES,
  BONUS_HISTORY,
  BONUS_PAGE,
  COMMON_ERROR,
  BONUSES_COLLECTING_GAMES,
  BONUSES_WAGERING_GAMES,
  BONUSES_WAGERING_GAMES_SCCOM,
  SPECIAL_OFFER_PAGE,
  SPECIAL_OFFERS,
  CATEGORY_DETAIL,
  RULES,
  RULES_DETAIL,
  HALL_OF_FAME,
  HALL_OF_FAME_HISTORY,
  SEARCH,
  CATEGORY_LIST,
  PROVIDER_LIST,
  PROVIDER_DETAIL,
} from '../constants/routeTemplates';

export const getRootRoute = () => ROOT;
export const getRulesRoute = () => RULES;
export const getRulesDetailsRoute = (id) =>
  RULES_DETAIL.replace(`:${PARAM_NAME.RULES}`, id);
export const getHallOfFameRoute = () => HALL_OF_FAME;
export const getHallOfFameHistoryRoute = () => HALL_OF_FAME_HISTORY;
export const getSearchRoute = () => SEARCH;

export const getBonusesRoute = () => BONUSES;
export const getSpecialOffersRoute = () => SPECIAL_OFFERS;
export const getBonusesHistoryRoute = () => BONUS_HISTORY;
export const getBonusesCollectionGamesRoute = () => BONUSES_COLLECTING_GAMES;
export const getBonusesWageringGamesRoute = () => BONUSES_WAGERING_GAMES;
export const getBonusesWageringGamesRouteSCCOM = () =>
  BONUSES_WAGERING_GAMES_SCCOM;
export const getBonusDetailRoute = (bonusId) =>
  BONUS_PAGE.replace(`:${PARAM_NAME.BONUS}`, bonusId);

export const getSpecialOfferDetailRoute = (id) =>
  SPECIAL_OFFER_PAGE.replace(`:${PARAM_NAME.OFFER}`, id);

export const getCategoriesRoute = () => CATEGORY_LIST;
export const getCategoryDetailRoute = (categoryId = '') =>
  CATEGORY_DETAIL.replace(':categoryId', categoryId);

export const getProvidersRoute = () => PROVIDER_LIST;
export const getProviderDetailsRoute = (providerId = '') =>
  PROVIDER_DETAIL.replace(':providerId', providerId);

export const getGameDetailRoute = (gameId = '') =>
  GAME.replace(`:${PARAM_NAME.GAME}`, gameId);
export const getDemoGameDetailRoute = (gameId = '') =>
  DEMO_GAME.replace(`:${PARAM_NAME.GAME}`, gameId);

export const getServerErrorRoute = (status = 500) =>
  generatePath(COMMON_ERROR, { status });
